<template>
  <v-container fluid>
    <v-layout row justify-space-around>
      <v-flex xs8>
        <v-layout column justify-space-around>
          <div style="margin:0 auto;">
            <v-img contain height=100 width=150 :src="require('../../images/vss_employee_logo.png')"></v-img>
          </div>
          <p style="text-align: center" class="error--text">{{ errors }}</p>
          <form @submit="login">
            <v-text-field
              v-model="username"
              label="Username"
              @change="clearErrors()"
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Password"
              type="password"
            ></v-text-field>
            <v-flex align-self-end>
              <v-btn type="submit" class="no-margin-button" color="success" @click.prevent="login">
                <v-icon left>forward</v-icon>
                Log In
              </v-btn>
              <router-link :to="{ name: 'forgotPassword' }">Forgot/Reset Password</router-link>
            </v-flex>
          </form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  data: function () {
    return {
      username: '',
      password: '',
      errors: '',
    }
  },
  methods: {
    clearErrors() {
      this.errors = ''
    },
    login() {
      let username = this.username
      let password = this.password
      this.$store.dispatch('userAuth/login', { username: username, password: password })
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => {
          this.password = ''
          this.errors = "That username and password combination was not found"
        })
    },
    fetchData () {
    },
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
